interface Route {
  [key: string]: string;
}

const routes: { [key: string]: Route } = {
  BOOKINGS: { en: 'my-ski-inn-reservations', fi: 'ski-inn-varaukseni' },
  HAUSVISE: {
    en: process.env.REACT_APP_HAUSVISE_URL ?? '',
    fi: process.env.REACT_APP_HAUSVISE_URL ?? '',
  },
  QUOTAS: { en: 'quotas', fi: 'kiintiot' },
  BENEFITS: { en: 'benefits', fi: 'edut' },
  ORDER_HISTORY: { en: 'purchase-history', fi: 'ostoshistoria' },
  SKIDAYS: { en: 'ski-stats', fi: 'laskupaivat' },
  ROOMS: { en: 'apartment-availability', fi: 'huoneiston-saatavuus' },
  ITICKET_REDIRECT: { en: 'iticket-redirect', fi: 'iticket-uudelleenohjaus' },
};

export { routes };
